import EventArgs from '../threading/EventArgs';
export default class SwipeEventArgs extends EventArgs {
    constructor(init) {
        super();
        Object.assign(this, init);
    }
}
//# sourceMappingURL=SwipeEventArgs.js.map